<template>
  <div>
    <div class="soup-queue-container">
      <div class="search-text-container">
        <div class="queues-container">
          <v-tabs hide-slider :height="38" :vertical="false" v-model="storeState.activeQueue" slider-color="yellow">
            <draggable v-model="storeState.settings.team.queues" class="v-slide-group__content v-tabs-bar__content">
              <v-tab v-for="tab in storeState.settings.team.queues" :key="tab.id" ripple>
                {{ tab.name }}
              </v-tab>
            </draggable>
          </v-tabs>
        <div>
        
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <span v-on="on" class="save-search-q">
                <v-btn icon @click="saveSearchAsQ">
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </span>
            </template>
            <span>Create queue</span>
          </v-tooltip>
        </div>
      </div>
    </div>
    <div class="search-container">
      <div>
        <div ref="searchResultsContainer">
          <div 
          :ref="'searchItem_' + index"
          :id="'searchItem_' + index"
          v-for="(row, index) in storeState.searchResults"
          :key="row.id"
          @mouseover="hoverRow(row)"
          @mouseleave="hoverRow(row)"
          @click="rowClick"
          :class="{
            'active': (index === storeState.searchIndex), 
            'row-hover': storeState.searchIndex < 0,
            'searchResultRows': true,
            }"
          >
            <div>
              <v-row>
                <v-col cols="12" sm="5" md="5">
                  <!-- {{ row.team_name }}  -->
                  <strong>{{ row.email }}</strong>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                  <span :class="{'row-reminder': true, 'red': store.pastDue(row).red}">{{getFromNow(row)}}</span>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <span v-if="getTags(row)">
                    <span v-for="tag in getTags(row)">
                      <v-chip label small class="mr-2">{{tag.text}}</v-chip>
                    </span>
                  </span>
                </v-col>
                <v-col cols="12" sm="1" md="1" class="text-right">
                  <span class="row-sub-title">
                    <v-icon>{{ ['trial', 'basic'].indexOf(row.plan_type) >= 0 ? 'mdi-emoticon-sad-outline' : 'mdi-currency-usd' }}</v-icon>
                  </span>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>  
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import InputTag from 'vue-input-tag'
import { store } from '../store.js';
import draggable from 'vuedraggable'
Vue.component('input-tag', InputTag)


export default {
  mounted() {
    let id = this.$route.params.id || 0
    let q = this.storeState.settings.team.queues[id].query
    this.storeState.searchTerm = q
    this.storeState.activeQueue = id
    // this.search({})
  },
  data() {
    return {
      storeState: store.state,
      store: store,
      underlay: '',
      tempSearch: '',
      newTag: '',
      tags: [],
    };
  },
  components: {
    draggable,
  },
  watch: {
    'storeState.activeQueue': {
        handler: function (val, oldVal) {
          console.log('watch 1', 'newval: ', val, '   oldVal:', oldVal)
          // this.$route.params.id = val
          this.$router.push({ name: 'Queues', params: { id: val }}).catch(err => console.error(err))
          let q = this.storeState.settings.team.queues.filter(q => q.id === Number(val))[0].query
          this.storeState.searchTerm = q
          this.search({})
        }
    }
  },
  filters: {
    fromNowFilter: function (data) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${data.email}`]
      if (details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    }
  },
  methods: {
    moment: function () {
      return moment();
    },
    hoverRow() {
      this.storeState.searchIndex = -1
    },
    rowClick(e) {
      console.log('enter: ', e)
      var self = this
      if (e.currentTarget.id) {
        console.log('e.currentTarget.id: ', e.currentTarget.id)
        this.$parent.openDetails('', Number(e.currentTarget.id.replace('searchItem_', '')))
      }
    },
    getFromNow: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    },
    getTags: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.tags) {
        return details.tags
      } else {
        return ''
      }
    },
    saveSearchAsQ() {
      this.$router.push({ path: '/search' }).catch(err => {})
    },
    validateSearch(val) {
      console.log('val term: ', val)
      this.storeState.searchTerm = this.newTag
      if (val.startsWith('#')) return true
      return false
    },
    search(e) {
      var self = this
      if (![13, 40, 38].includes(e.keyCode)) this.storeState.searchIndex = 0
      console.log('search term: ', this.storeState.searchTerm, e)
      if ([13, 40, 38].includes(e.keyCode)) {
        e.preventDefault()
        console.log('hit enter, up, down...')
        return
      }
      function successHandler(tx, results) {
        var arr = []
        console.log('found: ', results.rows.length)
        for (let i = 0; i < results.rows.length; i++) {
          let row = results.rows.item([i]);
          arr.push(row)
        }
        self.storeState.searchResults = arr
        self.$forceUpdate();
      }
      function errorHandler(transaction, error) {
        console.error(`Error : ${error.message}`);
      }
      function execSql(db, sql, q, successHandler) {
        db.transaction(function (tx) { 
            tx.executeSql(sql, [], successHandler, errorHandler); 
        })
      }
      // execSql(this.storeState.db, `SELECT * FROM users WHERE users MATCH '${this.storeState.searchTerm}' LIMIT 20`, '', successHandler)
      let sql = self.searchTermToSql(this.storeState.searchTerm)
      execSql(this.storeState.db, sql.sql, '', successHandler)
    },
    searchTermToSql(searchTerm) {
      searchTerm = searchTerm.toLowerCase()
      // let terms = searchTerm.split(' ')
      // let terms = searchTerm.split(/(?!' ')/g)
      var terms = searchTerm.split(/(\s+)/)
      let tags = []
      let reminders = []
      let texts = []
      let html = ''
      let where = ''
      var tagSql = ''
      var reminderSql = ''
      let detail_type = 'users'
      for (let i = 0; i < terms.length; i++) {
        let term = terms[i];
        if (term.startsWith('#')) {
          let fullTag = this.storeState.allTags.filter(o => o.text === term.replace('#', ''))
          if (fullTag.length > 0) {
            tags.push(term)
            tagSql+= `'${term.replace('#', '')}',`
            html+= `<span class="term-underlay">${term}</span>`
          } else {
            var suggestedTag = this.storeState.allTags.filter(o => o.text.startsWith(term.replace('#', '')))
            if (suggestedTag.length === 0) {
              console.log('no suggestions...')
            } else {
              suggestedTag = `#${suggestedTag[0].text}`
            }
            this.$refs.searchText
            this.storeState.suggestedTagDetails = {tag: suggestedTag, userEntered: term, start: this.$refs.searchText.selectionStart}
            html+= `<span class="term-underlay term-underlay-partial">${suggestedTag}</span>`
          }
        } else if (term.startsWith('!')) {
          reminders.push(term)
          let fullReminder = this.storeState.reminderOptions.filter(o => o.text === term.replace('!', ''))
          if (fullReminder.length > 0) {
            reminders.push(term)
            let r = fullReminder[0].calc().toISOString()
            // reminderSql = `select data_id from details where category = 'reminder' and data_value <= '${r};`
            reminderSql = `AND ('${detail_type}' || '-' || u.email) IN 
              (SELECT DISTINCT data_id
              FROM details as d
              WHERE category = 'reminder'
              and data_value <= '${r}')`
            html+= `<span class="term-underlay">${term}</span>`
          } else {
            var suggestedReminder = this.storeState.reminderOptions.filter(o => o.text.startsWith(term.replace('!', '')))
            if (suggestedReminder.length === 0) {
              console.log('no suggestions...')
            } else {
              suggestedReminder = `!${suggestedReminder[0].text}`
            }
            this.$refs.searchText
            this.storeState.suggestedReminderDetails = {reminder: suggestedReminder, userEntered: term, start: this.$refs.searchText.selectionStart}
            html+= `<span class="term-underlay term-underlay-partial">${suggestedReminder}</span>`
          }
        } else if (term === ' ') {
          html+= `<span class="term-underlay-text">${term}</span>`
        } else {
          texts.push(term)
          where+=`AND LOWER(email) LIKE '%${term}%'`
          html+= `<span class="term-underlay-text">${term}</span>`
        }
      }
      this.underlay = html
      tagSql = tagSql.slice(0, tagSql.length-1)
      if (tagSql.length > 0) {
        var tagSql = `AND ('${detail_type}' || '-' || u.email) IN 
        (SELECT DISTINCT data_id
        FROM details as d
        WHERE category = 'tag'
        and data_key in (${tagSql}))`
      }
      
      var sql = `
        SELECT u.*
        FROM users AS u
        WHERE 1=1
        ${where}
        ${tagSql}
        ${reminderSql}
        LIMIT 30
      `
      return {sql: sql, html: html}
    },
    getPath(path) {
      if (window.location.hostname === 'localhost') {
        return `http://localhost:5000${path}`
      }
      return  `https://seekwell.io${path}`
    },
  },
  created() {
    // this.getFoodFacts();
    // this.renderUserEntries();
  },
};
</script>

<style>
.active {
  background-color: #eee;
  border-left-color: #333;
  border-left-style: solid;
  border-left-width: 3px;
}
.searchResultRows {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 40px;
  padding-right: 30px;
}

.vue-input-tag-wrapper {
    background-color: #fff;
    border: none;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}

.vue-input-tag-wrapper .new-tag {
    background: transparent;
    border: none;
    color: #333;
    flex-grow: 1;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 6px;
    margin-top: 1px;
    outline: none;
    padding: 0px;
}

.vue-input-tag-wrapper .input-tag {
    background-color: #eee;
    border: 1px solid #eee;
    border-radius: 2px;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}
.searchResults {
  margin-top: 20px;
  margin-left: 2px;
}
.searchInput {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.dateContainer {
  width: 180px;
  padding-top: 30px;
}
.amount {
  width: 180px;
  /* width: 100%; */
}
.padded {
  padding: 20px;
}
.btn-pad {
  margin: 20px;
}
.search-input-container {
  padding-bottom: 20px;
  padding-left: 40px;
}
.row-sub-title {
  color: #ccc;
  padding-left: 10px;
}
.row-reminder {
  color: rgb(46, 170, 220);
  padding-left: 10px;
}
.save-search-q {
  float: right;
  margin-top: -35px;
  margin-right: 26px;
}
.search-text {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.search-container {
  padding-top: 65px;
}
.term-underlay {
  /* margin-left: 8px; */
  /* margin-top: 1px; */
  background: rgba(84, 172, 220, 0.2);
  box-shadow: 0 0 0 2px rgba(84, 172, 220, 0.2);
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.term-underlay-text {
  /* margin-left: 0px; */
  background: transparent;
  box-shadow: none;
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.term-underlay-partial {
  /* margin-left: 0px; */
  background: rgba(249, 150, 255, 0.2);
  box-shadow: none;
}
.search-underlay {
  position: absolute;
  width: 100%;
}
.search-text-container {
  position: absolute;
  width: 100%;
  height: 38px;
  font-size: 20px;
  outline: none;
}
#soupSearchContainer {
  display: -webkit-inline-box;
  position: absolute;
  width: 100%;
  margin-left: 20px;
}
.soup-queue-container {
  margin-left: 0px;
  margin-top: 25px;
  margin-bottom: 20px;
}
.queues-container {
  margin-left: 28px;
}
</style>